<template>
  <div class="app-tariff-status">
    <slot name="txtBeforeFormattedTariffStatus"></slot>
    <ConsumptionList v-if="consumptions.consumptionsForUnit"
      :consumptions="consumptions.consumptionsForUnit"
      :consumption-title="false"
    >
      <template v-for="slot in possibleChildSlotsFor('ConsumptionTitle')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ConsumptionList>
    <MultipleOptionsTable :options.sync="bookedOptions"
                          :consumptions="consumptions.consumptionsForUnit">
      <template v-for="slot in possibleChildSlotsFor('OptionsTable')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </MultipleOptionsTable>
    <slot name="txtAfterFormattedTariffStatus"></slot>
  </div>
</template>

<script>
import MultipleOptionsTable from './MultipleOptionsTable.vue'
import gql from 'graphql-tag'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import ConsumptionList from '@/components/process/generic/Consumption/lidl/ConsumptionList.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'TariffStatus',
  components: { ConsumptionList, MultipleOptionsTable },
  data () {
    return {
      tariffoptions: {
        bookedTariffoptions: {
          bookedTariffoptions: []
        }
      },
      consumptions: {
        consumptionsForUnit: []
      }
    }
  },
  props: {
    extraTariffOptions: {
      type: Object,
      default: () => {
      }
    }
  },
  mixins: [
    transaction('bookTariffOptions'),
    slotProxy()
  ],
  computed: {
    bookedOptions: function () {
      const me = this
      return (this.tariffoptions?.bookedTariffoptions?.bookedTariffoptions || []).map(tariffOption => {
        return Object.assign(
          {},
          tariffOption,
          {
            id: tariffOption.tariffoptionId,
            endOfRuntime: tariffOption.endOfRuntime
          },
          (me.extraTariffOptions ? me.extraTariffOptions[tariffOption.tariffoptionId] || '' : '')
        )
      })
    }
  },
  apollo: {
    tariffoptions: function () {
      return wrapQuery(
        gql`query bookTariffOptions {
            tariffoptions {
                bookedTariffoptions {
                    bookedTariffoptions {
                        volumes {
                            unit
                            amount
                            type
                            formattedUnit
                        }
                        tariffoptionId
                        name
                        state
                        price
                        duration {
                            amount
                            unit
                        }
                        statusKey
                        startOfRuntime
                        endOfRuntime
                    }
                },
                bookableTariffoptions {
                    bookableTariffoptions {
                        tariffoptionId
                        name
                        price
                        duration {
                            amount
                            unit
                        }
                        notBookableWith
                        requiresContractSummary
                    }
                }
            }
        }`, this, 'tariffoptions'
      )
    },
    consumptions: function () {
      return wrapQuery(
        gql`query bookTariffOptions {
            consumptions {
                consumptionsForUnit {
                  consumed
                  unit
                  type
                  expirationDate
                  left
                  formattedUnit
                  max
                  tariffOrOptions {
                    name
                    id
                    type
                    consumptions {
                      consumed
                      unit
                      type
                      expirationDate
                      left
                      max
                    }
                  }
                }
            }
        }`, this, 'consumptions'
      )
    }
  }
}
</script>
